import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getMyWalletApi, initiateTopUpApi, getPricingApi } from '../api/wallet';
import { useToast } from '../context/ToastContext';

export const useWallet = () =>
  useQuery({ queryKey: ['wallet'], queryFn: getMyWalletApi });

export const useInitiateTopUp = () => {
  const { error } = useToast();
  return useMutation({
    mutationFn: ({ amount, phone }) => initiateTopUpApi({ amount, phone }),
    onError: (e) => error(e?.message || 'Failed to initiate top-up.'),
  });
};

export const usePricing = () =>
  useQuery({ queryKey: ['pricing'], queryFn: getPricingApi, staleTime: 5 * 60 * 1000 });

export const useRefreshWallet = () => {
  const queryClient = useQueryClient();
  return () => queryClient.invalidateQueries({ queryKey: ['wallet'] });
};
